import { render, staticRenderFns } from "./ExternalPayment.vue?vue&type=template&id=652a3a0f&scoped=true&"
import script from "./ExternalPayment.vue?vue&type=script&lang=js&"
export * from "./ExternalPayment.vue?vue&type=script&lang=js&"
import style0 from "./ExternalPayment.vue?vue&type=style&index=0&id=652a3a0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652a3a0f",
  null
  
)

export default component.exports